import { ActionTypes } from './constants';

export const hideMap = () => ({
    type: ActionTypes.HIDE_MAP,
});
